(ns ballot-scout-v2-frontend.dashboard.views.days-in-service
  (:require
   [ballot-scout-v2-frontend.components.export :refer [export-menu]]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.search :refer [clear-button]]
   [ballot-scout-v2-frontend.dashboard.events :as e.dashboard]
   [ballot-scout-v2-frontend.dashboard.subs :as s.dashboard]
   [ballot-scout-v2-frontend.dashboard.views.fragments :as fragments]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.subs :as subs]
   [ballot-scout-v2-frontend.util :as util]
   [clojure.string :as str]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def table-keys
  [[:zipcode [:<> [:span.is-hidden-mobile "Destination"] [:span.is-hidden-tablet "Dest"]]]
   [:average [:<> [:span.is-hidden-mobile "Average"] [:span.is-hidden-tablet "Avg"]]]
   [:high [:<> [:span.is-hidden-mobile "High"] [:span.is-hidden-tablet "Hi"]]]
   [:low [:<> [:span.is-hidden-mobile "Low"] [:span.is-hidden-tablet "Lo"]]]])

(defn format-table-data
  [zipcode-map]
  (for [[zip m] zipcode-map]
    {:zipcode zip
     :average (Math/ceil (/ (:sumofdays m) (:count m)))
     :high (:high m)
     :low (:low m)}))

(defn days-in-service-row
  [row]
  (into [:tr {:id (str "days-in-svc-" (:zipcode row))}]
        (for [entry table-keys]
          [:td (get row (first entry))])))

(defn sortable-th [key name sort-col sort-dir]
  (let [sort-active? (= key @sort-col)
        asc? (and sort-active? (= :asc @sort-dir))
        desc? (and sort-active? (= :desc @sort-dir))
        transition-to (if asc? :desc :asc)]
    [:th {:class "sortable is-family-primary"
          :on-click #(do
                       (reset! sort-col key)
                       (reset! sort-dir transition-to))}
     name
     [:span {:class "icon"}
      (cond asc?  [icon ::icon/sort-up]
            desc? [icon ::icon/sort-down]
            :else [icon ::icon/sort])]]))

(defn jurisdiction-prep-export!
  [mimetype]
  (rf/dispatch
   [::e.dashboard/create-dis-export-for-jurisdiction
    (:jurisdiction/id @(rf/subscribe [::subs/current-jurisdiction]))
    (:election/id @(rf/subscribe [::subs/current-election]))
    mimetype]))

(defn partner-prep-export!
  [mimetype]
  (rf/dispatch
   [::e.dashboard/create-dis-export-for-partner
    (:partner/id @(rf/subscribe [::subs/current-partner]))
    (:election/id @(rf/subscribe [::subs/current-election]))
    mimetype]))

(defn export-view [export-state]
  (case (:status @export-state)
    :ready [:div {:class "export-view alert-success is-flex is-justify-content-space-between"}
            [:strong "Your export is ready! "]
            [:a.download-link {:class "has-text-underlined"
                               :on-click #(rf/dispatch [::e.dashboard/clear-dis-export-state])
                               :href (:link @export-state) :download "ballot-export.csv"}
             "Download " (util/get-readable-filename-from-s3-link (:link @export-state))]
            [:a {:class "has-text-underlined is-align-flex-end"
                 :on-click #(rf/dispatch [::e.dashboard/clear-dis-export-state])}
             [:small "Discard"]]]

    :empty-export [:div {:class "export-view is-4"}
                   "No ballots found for export"]

    :errored [:div {:class "export-view is-4"}
              "There was an error with your export"]

    ;else
    nil))

(defn days-in-service-table
  []
  (let [filter-string (r/atom nil)
        sort-col (r/atom :average)
        sort-dir (r/atom :desc)
        export-fn (if @(rf/subscribe [::subs/on-partner-admin-page?])
                    partner-prep-export!
                    jurisdiction-prep-export!)
        export-state (rf/subscribe [::s.dashboard/dis-export])]
    (fn []
      (let [stats-data @(rf/subscribe [::s.dashboard/days-in-service-stats])
            generating-export? (contains? #{:creating :generating} (:status @export-state))
            invalid-filter-string? (and (string? @filter-string) (not (re-matches #"^[0-9]{0,5}$" @filter-string)))
            filtered-rows (if (nil? @filter-string)
                            stats-data
                            (->> stats-data keys (filter #(str/starts-with? % @filter-string)) (select-keys stats-data)))
            sorted-rows (if (= @sort-dir :asc)
                          (sort-by @sort-col (format-table-data filtered-rows))
                          (sort-by @sort-col #(compare %2 %1) (format-table-data filtered-rows)))]
        [:<>
         [:div {:class "search-and-export"}
          [:div {:class "control is-flex is-align-items-center is-expanded button-in"}
           [:input {:class (str "input" (when invalid-filter-string? " is-danger"))
                    :aria-label "Filter by zipcode"
                    :value @filter-string
                    :on-change #(reset! filter-string (-> % .-target .-value))
                    :placeholder "Filter by zipcode"}]
           (when-not (str/blank? @filter-string)
             [clear-button #(reset! filter-string nil)])]
          [export-menu {:on-click export-fn
                        :button-text [:span
                                      (if generating-export?
                                        [icon ::icon/spinner {:pulse? true}]
                                        [icon ::icon/download])
                                      [:span {:class "ml-3 is-hidden-mobile"} "Export Table"]]
                        :align-right? true
                        :disabled (or invalid-filter-string? generating-export?)}]]
         (when invalid-filter-string?
           [:small.invalid-zip-warning {:class "mt-2 is-fullwidth is-flex is-align-content-flex-start"}
            "Please enter a valid zipcode, up to 5 digits."])
         [export-view export-state]
         [:div.table-container
          [:table {:class "table is-striped is-hoverable"}
           [:thead (into [:tr.table-header]
                         (for [[key name] table-keys]
                           [sortable-th key name sort-col sort-dir]))
            (if (empty? sorted-rows)
              [:tbody
               [:div.no-results {:class "is-flex is-align-items-center is-justify-content-center"}
                "No results found"]]
              (into [:tbody] (map days-in-service-row sorted-rows)))]]]]))))

(defn days-in-service-view
  []
  (let [current-route @(rf/subscribe [:ballot-scout-v2-frontend.routes/current-route])
        stats-data @(rf/subscribe [::s.dashboard/days-in-service-stats])
        fetch-error (if @(rf/subscribe [::subs/on-partner-admin-page?])
                      @(rf/subscribe [::request-helpers/failed-request
                                      [::e.dashboard/fetch-days-in-service-for-partner current-route]])
                      @(rf/subscribe [::request-helpers/failed-request
                                      [::e.dashboard/fetch-days-in-service-for-jurisdiction current-route]]))]
    (fragments/title-section
     [:div.home-view.days-in-service {:class "is-flex is-justify-content-center is-fullwidth"}
      [:div.days-in-service-content {:class "is-flex is-flex-direction-column is-align-items-center"}
       [:h2.title.heading-2 "Days in Service by Destination"]
       (cond
         (some? fetch-error)
         [:h4.heading-4.no-data
          "There was an error loading ballot data."]

         (= stats-data :loading)
         [:div.loading
          [:img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]]

         (and (seqable? stats-data) (> (count stats-data) 0))
         [days-in-service-table]

         :else
         [:h4.heading-4.no-data
          "Waiting for scan data, please check back later."])]])))
